import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { IconChevronLeft, IconChevronRight, IconClose } from '@travel-frontend/icons';
import { useTranslation } from 'next-i18next';
import { useCallback, useRef, useState } from 'react';
import { Content } from '../../../../components/MobileMenu/components/Content.js';
import { HoverWrapper } from '../../../../components/MobileMenu/components/MenuItem/components/HoverWrapper.js';
import { Title } from '../../../../components/MobileMenu/components/MenuItem/components/Title.js';
import { ControlApp } from '../../../../components/HeaderNew/components/ControlApp.js';
import { LinkItem } from '../../../../components/Menu/components/LinkItem.js';
import { Collapse, Drawer, Stack } from '../../../../primitives/index.js';
import { SPACING_NONE, SPACING_SMALL } from '../../../../utils/spacingLegacy.js';
export const MenuItem = ({
  label,
  link,
  onClose,
  children
}) => {
  const {
    t
  } = useTranslation();
  const [subMenuVisible, setSubMenuVisible] = useState(false);
  const ref = useRef(null);
  const handleClick = useCallback(e => {
    if (e.currentTarget.nodeName === 'A') {
      e.stopPropagation();
      return;
    }
    if (!subMenuVisible && ref.current) {
      ref.current.scrollIntoView({
        behavior: 'smooth'
      });
    }
    setSubMenuVisible(previous => !previous);
  }, [subMenuVisible]);
  const handleDrawerClose = () => {
    setSubMenuVisible(false);
  };
  return _jsxs("div", {
    children: [_jsxs(Title, {
      ref: ref,
      onClick: handleClick,
      children: [link ? _jsx(LinkItem, {
        url: link.path,
        masked: link.masked,
        target: link.target,
        children: label
      }) : label, children && (subMenuVisible ? _jsx(IconChevronLeft, {}) : _jsx(IconChevronRight, {}))]
    }), children && _jsx(Collapse, {
      in: subMenuVisible,
      children: _jsx(Drawer, {
        open: subMenuVisible,
        anchor: "right",
        onClose: handleDrawerClose,
        children: _jsxs(Content, {
          spacing: SPACING_NONE,
          children: [_jsx(ControlApp, {
            onClick: onClose,
            children: _jsx(IconClose, {
              fontScale: "large"
            })
          }), _jsxs(Stack, {
            divider: true,
            spacing: SPACING_SMALL,
            children: [_jsx(HoverWrapper, {
              children: _jsxs(Stack, {
                onClick: handleDrawerClose,
                justifyContent: "flex-start",
                alignItems: "center",
                direction: "row",
                spacing: SPACING_SMALL,
                children: [_jsx(IconChevronLeft, {}), _jsx(Stack, {
                  children: t('headerNew:returnButton')
                })]
              })
            }), children]
          })]
        })
      })
    })]
  });
};